/* eslint-disable */
import { Component } from 'react';
import { isTrue } from '../../../../helpers/isTrue';
import Message from '../../../Message';
import { deleteUser } from '../../../Onboarding/components/queries';
import { withTranslation } from 'react-i18next';

class Users extends Component {
    constructor() {
        super();
        this.linkedAccounts = window.linkedAccounts ?? [];
        this.user_data = window.user_data ?? {};
        this.viewers = window.viewers ?? [];
        this.onDeleteUser = this.onDeleteUser.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);

        try {
            this.permission_errors = JSON.parse(this.props.permission_errors) ?? [];
        } catch (err) {
            this.permission_errors = [];
        }

        this.state = {
            loading: false,
            message: '',
            message_tags: '',
        };
    }

    async onDeleteUser(id) {
        try {
            this.setState({
                loading: true,
            });
            const res = await deleteUser(id);
            if (res.status === 204) {
                window.location.reload();
            } else {
                this.setState({
                    loading: false,
                    message: 'Something went wrong.',
                    message_tags: 'error',
                });
            }
        } catch (err) {
            consoel.log(err);
            this.setState({
                loading: false,
                message: 'Something went wrong.',
                message_tags: 'error',
            });
        }
    }

    deleteMessage() {
        this.setState({ message: '' });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="settings-card settings-linked-accounts">
                <div className="settings-linked-accounts-header">
                    <div className="d-flex align-items-center">
                        {t('settings.users.header')}
                        {!this.props.isViewer && (
                            <div className="settings-domains-tag">
                                {t('settings.users.seat_used', {
                                    user_viewers_count: this.props.user_viewers_count,
                                    available_viewers: this.props.available_viewers,
                                })}
                            </div>
                        )}
                    </div>
                    {!this.props.isViewer && (
                        <div className="d-flex gap-8">
                            <a
                                href="/tools/add-ons/?part=seats"
                                className="button button-filled button-primary"
                            >
                                {t('settings.users.buy_more_seats')}
                            </a>
                            {!isTrue(this.props.is_deactivated) && (
                                <a
                                    href="/customers/add-user"
                                    className="button button-filled button-primary"
                                >
                                    {t('settings.users.add_user')}
                                </a>
                            )}
                        </div>
                    )}
                </div>
                <div className="settings-linked-accounts-body">
                    <div className="settings-linked-accounts-item">
                        <div className="settings-linked-accounts-item-left">
                            <div className="settings-icon-first-letter">
                                {this.user_data?.first_latter}
                            </div>
                            <div className="settings-linked-accounts-item-left-text">
                                <div>{this.user_data.full_name} (Admin)</div>
                                {this.user_data?.client_email && (
                                    <div className="settings-linked-accounts-item-left-text-bottom ">
                                        {this.user_data?.client_email}{' '}
                                    </div>
                                )}
                            </div>
                        </div>
                        {!isTrue(this.props.is_deactivated) && !this.props.isViewer && (
                            <a
                                href="/customers/change_customer_profile"
                                className="settings-action-btn"
                            >
                                <i className="icon-edit"></i>
                            </a>
                        )}
                    </div>
                    {!!this.viewers.length &&
                        !this.props.isViewer &&
                        this.viewers?.map((item, i) => (
                            <div key={i} className="settings-linked-accounts-item">
                                <div className="settings-linked-accounts-item-left">
                                    <div className="settings-icon-first-letter">
                                        {item?.first_latter}
                                    </div>
                                    <div className="settings-linked-accounts-item-left-text">
                                        <div>{item.full_name}</div>
                                        {item.client_email && (
                                            <div className="settings-linked-accounts-item-left-text-bottom users">
                                                {item.client_email}{' '}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {!isTrue(this.props.is_deactivated) && (
                                    <div className="settings-linked-accounts-action-btns">
                                        {isTrue(item.active) ? (
                                            <a href={`/customers/deactivate-user/${item.id}`}>
                                                <span className={`switch-button active`}>
                                                    <span className="switch-circle"></span>
                                                </span>
                                            </a>
                                        ) : (
                                            <a href={`/customers/reactivate-user/${item.id}`}>
                                                <span className={`switch-button not-active`}>
                                                    <span className="switch-circle" />
                                                </span>
                                            </a>
                                        )}
                                        <a
                                            href={`/customers/edit-user/${item.id}`}
                                            className="settings-action-btn"
                                        >
                                            <i className="icon-edit"></i>
                                        </a>
                                        {/* <button
                                            disabled={this.state.loading}
                                            className="settings-action-btn"
                                            onClick={() => this.onDeleteUser(item.id)}
                                        >
                                            {this.state.loading ? (
                                                <Loading onlyPreloader />
                                            ) : (
                                                <i className="icon-delete"></i>
                                            )}
                                        </button> */}
                                    </div>
                                )}
                            </div>
                        ))}
                </div>
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tags}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default withTranslation()(Users);
